import type { ComputedRef, InjectionKey, Slot } from 'vue';
import type { NxConditionField, NxConditionOperators } from './model';

/** Labels of the builder, all German by default. */
export interface NxConditionBuilderLabels {
  and: string;
  or: string;
  combinator: string;
  addRule: string;
  addGroup: string;
  remove: string;
  duplicate: string;
  field: string;
  fieldPlaceholder: string;
  operator: string;
  value: string;
  valueFrom: string;
  valueTo: string;
  valueList: string;
  empty: string;
  rule: string;
  group: string;
}

/** What the nested groups read from the builder. */
export interface ConditionBuilderContext {
  fields: ComputedRef<readonly NxConditionField[]>;
  operators: ComputedRef<NxConditionOperators>;
  maxDepth: ComputedRef<number>;
  disabled: ComputedRef<boolean>;
  labels: ComputedRef<NxConditionBuilderLabels>;
  /** The caller's `#value` slot, handed down to every rule. */
  valueSlot: () => Slot | undefined;
}

export const conditionBuilderKey: InjectionKey<ConditionBuilderContext> =
  Symbol('nx-condition-builder');
